const getAppliedFilters = ({ initialValues, filtersMaps }) => {
  const appliedFilters = [];
  const keys = Object.keys(initialValues).sort();
  // eslint-disable-next-line
  for (let index = 0; index < keys.length; index++) {
    if (keys[index] === 'min_offer_price' && initialValues[keys[index]].length > 0) {
      const selectedFacet = {
        id: '',
        displayName: '',
        facetName: '',
      };
      const list = [];
      selectedFacet.id = initialValues[keys[index]];
      // eslint-disable-next-line prefer-destructuring
      selectedFacet.displayName = initialValues[keys[index]][0];
      selectedFacet.facetName = 'min_offer_price';
      list.push(selectedFacet);
      appliedFilters.push(list);
    } else {
      const selectedFacet = filtersMaps[keys[index]]
        ? initialValues[keys[index]].map((filterId) =>
            filtersMaps[keys[index]].find((filter) => filterId === filter.id)
          )
        : [];
      appliedFilters.push(selectedFacet);
    }
  }
  return appliedFilters;
};

const setFilterOptions = (selectedFilterOption, filterKeys, updatedFacetNames) => {
  if (selectedFilterOption.toUpperCase().includes('FILTER') || selectedFilterOption.length === 0) {
    return filterKeys;
  }
  return [
    Object.keys(updatedFacetNames)[Object.values(updatedFacetNames).indexOf(selectedFilterOption)],
  ];
};

const checkMaxMinPriceRange = (priceRangeData) => {
  if (priceRangeData?.min === priceRangeData?.max) {
    return false;
  }
  return true;
};

const FILTER_DISPLAY_NAME_MAP = {
  TCPStyleQTYUS_uFilter: 'Multipacks',
  age_group_uFilter: 'Age Group',
};

const facetNameChange = (unbxdKeyMapping) => {
  return {
    ...unbxdKeyMapping,
    TCPStyleQTYUS_uFilter: FILTER_DISPLAY_NAME_MAP.TCPStyleQTYUS_uFilter,
    age_group_uFilter: FILTER_DISPLAY_NAME_MAP.age_group_uFilter,
  };
};

export { getAppliedFilters, setFilterOptions, checkMaxMinPriceRange, facetNameChange };
